/**
 * 获取相差的天数
 * @param start_time
 */
const one_day = 1000 * 60 * 60 * 24;
export const getDiffDays = (start_time, end_time) => {
  if (!start_time) return 0;

  const diff = Math.abs(end_time - start_time);
  const days = Math.floor(diff / one_day);
  return days;
};
